<ng-template [ngIf]="pageStatus === 0"></ng-template>
<ng-template [ngIf]="pageStatus === 404">Page not found.</ng-template>
<ng-template [ngIf]="pageStatus === 500">Error loading page.</ng-template>
<ng-template [ngIf]="pageStatus === 200">


	<ng-container *ngFor="let zone of page.zones | keyvalue">
		<!-- TODO: wrap this in a page template component -->
		<ng-container *ngFor="let moduleRef of zone.value">
			<app-agility-module [moduleObj]="moduleRef" [page]="this.page" [dynamicPageItem]="this.dynamicPageItem"></app-agility-module>
		</ng-container>
	</ng-container>

</ng-template>
